import { round, uniq } from 'lodash';
import { QuantityWithUnits } from '../domain/property-types';

export const formatQuantity = (quantity: QuantityWithUnits): string => {
  const formatNumericValue = (value: number): string =>
    round(value, 2).toString();

  const formatValue = (value: number | string): string =>
    typeof value === 'number' ? formatNumericValue(value) : value;

  if (typeof quantity.value === 'string') {
    return quantity.value;
  }
  if (typeof quantity.value === 'number') {
    return formatValue(quantity.value);
  }
  if (Array.isArray(quantity.value)) {
    return uniq(
      quantity.value
        .filter((v) => typeof v !== 'number' || !isNaN(v))
        .map((v) => formatValue(v))
    ).join(', ');
  }

  return '';
};
